<template>
    <b-modal id="modal-row-detail" title="Test Case Result" centered>
        <template v-if="row">
            <div class="d-flex flex-column" style="gap: 0.875rem; font-size: 0.875rem;">
                <!-- Sentence with highlights -->
                <div>
                    <span class="label">Sentence</span>
                    <p class="mb-0 mt-1" style="color: #1f2937; line-height: 1.6;"
                        v-html="highlightedSentence" />
                </div>

                <!-- Matched keywords -->
                <template v-if="row.detail">
                    <div>
                        <span class="label">Matched Keyword Open Incident</span>
                        <div class="mt-1 d-flex flex-wrap" style="gap: 0.375rem;">
                            <template v-if="row.detail.matched_include && row.detail.matched_include.length > 0">
                                <span v-for="kw in row.detail.matched_include" :key="kw" style="font-size: 0.75rem;">
                                    {{ kw }}
                                </span>
                            </template>
                            <span v-else style="font-size: 0.75rem;">-</span>
                        </div>
                    </div>
                    <div>
                        <span class="label">Matched Keyword Not Open Incident</span>
                        <div class="mt-1 d-flex flex-wrap" style="gap: 0.375rem;">
                            <template v-if="row.detail.matched_not_include && row.detail.matched_not_include.length > 0">
                                <span v-for="kw in row.detail.matched_not_include" :key="kw" style="font-size: 0.75rem;">
                                    {{ kw }}
                                </span>
                            </template>
                            <span v-else style="font-size: 0.75rem;">-</span>
                        </div>
                    </div>

                    <small v-if="!(row.detail.matched_include && row.detail.matched_include.length) && !(row.detail.matched_not_include && row.detail.matched_not_include.length)"
                        class="text-danger">*ในกรณีที่ไม่พบ Keyword ที่ตรงกับทั้ง Open Incident และ Not Open Incident ระบบ AI จะเป็นผู้ประมวลผล*</small>
                </template>
            </div>
        </template>

        <template #modal-footer v-if="row">
            <div class="d-flex" style="gap: 1.5rem; font-size: 0.875rem;">
                <div>
                    <span class="label">Expected</span>
                    <p class="mb-0 mt-1" style="color: #374151;">{{ row.expect }}</p>
                </div>
                <div>
                    <span class="label">Result</span>
                    <p class="mb-0 mt-1"
                        :style="{ color: row.isCorrect ? '#16a34a' : '#ef4444' }">
                        {{ row.result }}
                    </p>
                </div>
                <div>
                    <span class="label">Status</span>
                    <p class="mb-0 mt-1 d-flex align-items-center" style="gap: 0.25rem;"
                        :style="{ color: row.isCorrect ? '#16a34a' : '#ef4444' }">
                        <font-awesome-icon
                            :icon="row.isCorrect ? 'fa-solid fa-check-circle' : 'fa-solid fa-times-circle'"
                            style="pointer-events: none;" />
                        {{ row.isCorrect ? 'Pass' : 'Fail' }}
                    </p>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'TestCaseResultModal',
    props: {
        row: {
            type: Object,
            default: null,
        },
    },
    computed: {
        highlightedSentence() {
            if (!this.row) return ''
            const sentence = this.row.value
            if (!this.row.detail) return this.escapeHtml(sentence)

            const includeKws = this.row.detail.matched_include || []
            const notIncludeKws = this.row.detail.matched_not_include || []
            if (!includeKws.length && !notIncludeKws.length) return this.escapeHtml(sentence)

            const kwMap = new Map()
            includeKws.forEach(kw => kwMap.set(kw, '#bbf7d0'))
            notIncludeKws.forEach(kw => kwMap.set(kw, '#fecaca'))

            const sortedKws = [...kwMap.keys()].sort((a, b) => b.length - a.length)
            const escaped = sortedKws.map(kw => kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            const regex = new RegExp(`(${escaped.join('|')})`, 'g')

            return sentence.split(regex).map(part => {
                if (kwMap.has(part)) {
                    return `<mark style="background:${kwMap.get(part)};padding:0 2px;border-radius:2px;">${this.escapeHtml(part)}</mark>`
                }
                return this.escapeHtml(part)
            }).join('')
        },
    },
    methods: {
        escapeHtml(str) {
            return str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
        },
    },
}
</script>

<style scoped>
.label {
    color: #000000;
    font-size: 0.75rem;
    font-weight: 500;
}

::v-deep #modal-row-detail .modal-footer {
    justify-content: flex-start;
    padding: 5px 12px;
}
</style>